import React from 'react';
import PropTypes from 'prop-types';
import bb from 'billboard.js';
const d3 = require("d3");
const Moment = require('moment');
const _  = {
    forEach: require('lodash/forEach'),
}

const Globals = require('../../../../app/globals');

const DEFAULT_HEIGHT = 230;
const DEFAULT_WIDTH = undefined; // responsive width
const DEFAULT_TITLE_FS = 3;

const propTypes = {
    columns: PropTypes.array, // date range column (array) MUST be index 0 of this array
    colors: PropTypes.object,
    id: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    format: PropTypes.oneOf(['$', ',', '%']),
    transitionDuration: PropTypes.number,
    legendShow: PropTypes.bool,
    yInt: PropTypes.bool,
    yMin: PropTypes.number,
    onPointClick: PropTypes.func,
    xTickFormat: PropTypes.string,
};

const defaultProps = {
    columns: [],
    colors: {},
    height: DEFAULT_HEIGHT,
    width: DEFAULT_WIDTH,
    format: ',',
    transitionDuration: 0,
    legendShow: false,
    yInt: false,
    yMin: 0,
    onPointClick: null,
    xTickFormat: "%Y-%m-%d",
};

class TimeseriesChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedDate: null
        };

        this.chart = null;

        this.onSelectPoint = this.onSelectPoint.bind(this);
    }

    onSelectPoint(data, element) {
        if (this.props.onPointClick) {
            let selectedDate = null;
            // depends on c3 library maintaining _selected_ classname as indicator of selection
            // if (element.classList.contains('_selected_')) { // TODO: see util/polyfill.js. classList polyfill broken in IE11
            if (element.className && element.className.baseVal) {
                let classList = element.className.baseVal;
                if (typeof classList === 'string' && classList.indexOf('_selected_') > 0) {
                    selectedDate = Moment(data.x).format('YYYY-MM-DD');
                }
            }
            else {
                console.warn('element has no className');
            }

            this.setState({ selectedDate: selectedDate })
            this.props.onPointClick(selectedDate);
        }
    }

    componentDidMount() {
        const self = this;

        let size = {
            height: this.props.height
        }
        if (this.props.width) {
            size.width = this.props.width;
        }

        let y = { min: this.props.yMin };
        if (this.props.yInt) {
            y.tick = {};
            y.tick.format = (d) => {
                return d % 1 === 0 ? d : "";
            }
        }

        let colors = {...this.props.colors};
        _.forEach(this.props.columns,(entry,i)=>{
            let name = entry[0];
            if (typeof name === 'string') {
                if (!colors[name]) {
                    colors[name] = Globals.CHART_COLORS[i];
                } 
            }
        })

        let createData = {
            bindto: `#${self.props.id}`,
            data: {
                x: 'x',
                columns: self.props.columns,
                colors
            },
            axis: {
                x: {
                    type: 'timeseries',
                    tick: {
                        format: self.props.xTickFormat
                    }
                },
                y: y
            },
            legend: {
                show: self.props.legendShow
            },
            size: size,
            tooltip: {
                format: {
                    value: function (value, ratio, id) {
                        const format = d3.format(self.props.format);
                        return format(value);
                    }
                }
            },
            transition: {
                duration: self.props.transitionDuration
            }
        }

        if (this.props.onPointClick) {
            createData.data.selection = {
                enabled: true,
                multiple: false
            };

            createData.data.onclick = this.onSelectPoint;
        }

        this.chart = bb.generate(createData);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        // reset selected point if it falls outside of new date range
        // assumes that date range column (array) is index 0 value of this.props.columns array
        if (this.state.selectedDate) {
            const newTimeseriesColumn = newProps.columns[0];
            const newStartDate = Moment(newTimeseriesColumn[1]);
            const newEndDate = Moment(newTimeseriesColumn[newTimeseriesColumn.length - 1]);

            const oldTimeseriesColumn = this.props.columns[0];
            const oldStartDate = Moment(oldTimeseriesColumn[1]);
            const oldEndDate = Moment(oldTimeseriesColumn[oldTimeseriesColumn.length - 1]);

            // const selectedDate = Moment(this.state.selectedDate);
            // TODO: loading new columns while keeping the same selection causes the
            // selection style to show up in incorrect positions (below or above the graph point)
            // ... for now, we're always de-selecting any selection when the dates change
            // if (selectedDate < newStartDate || selectedDate > newEndDate || true) {

            if (!oldStartDate.isSame(newStartDate) || !oldEndDate.isSame(newEndDate)) {
                this.setState({ selectedDate: null });
                let dataSetNames = this.props.columns.slice(1).map(column => {
                    return column[0];
                });

                this.chart.unselect(dataSetNames);

                if (this.props.onPointClick) {
                    this.props.onPointClick(null);
                }
            }
        }

        this.chart.load({
            columns: newProps.columns
        });
    }

    componentWillUnmount() {
        delete this.chart;
    }

    render() {
        return (
            <div id={this.props.id} style={{width: "100%"}} />
        );
    }
}

TimeseriesChart.propTypes = propTypes;
TimeseriesChart.defaultProps = defaultProps;

export default TimeseriesChart;
